import { Route, Routes } from "react-router-dom";
import AssessmentDetail from "./AssessmentDetail";
import AssessmentList from "./AssessmentList";
import AssessmentReports from "./reports";
import AssessmentSummaryPage from "./summary";

const Assessment = () => {
  return (
    <Routes>
      <Route index element={<AssessmentList />} />
      <Route path="summary/*" element={<AssessmentSummaryPage />} />
      <Route path="reports" element={<AssessmentReports />} />
      <Route path=":id" element={<AssessmentDetail />} />
    </Routes>
  );
};

export default Assessment;
